export const colors = {
	primary: '#0d1117',
	secondary: '#161b22',
	header: '#272141cc',
	primaryButtonColor: '#2ecc71',
	voteUpColor: '#4CAF50',
	voteDownColor: '#F44336',
	primaryBorder: '#30363d',
	primaryText: '#e6edf3'
}
